import { hasContractorAdmin, type Features } from "@neus/shared";

declare const __FEATURES__: Features;

/**
 * This build's feature flags (VITE_FEATURE_* at build time, checked in vite.config.ts). A feature
 * that's off has no routes, links or menu items here, and the API answers 404 for it.
 */
export const features: Features = __FEATURES__;

/** The admin contractor pages: with contractor pricing or contractor approval on. */
export const contractorAdmin = hasContractorAdmin(features);
